import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/shared/Sidebar';
import DragDropGroupAssignment from '../components/group/DragDropGroupAssignment';

const DragDropDealerGroupPage: React.FC = () => {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="dashboard-page">
      <Sidebar />
      
      <div className="dashboard-main">
        <div className="dashboard-content">
          <div className="breadcrumbs">
            <button className="breadcrumb-link" onClick={goToDashboard}>
              Dashboard
            </button>
            <span className="breadcrumb-separator">/</span>
            <span className="breadcrumb-current">Location Group Assignment</span>
          </div>

          <div className="content-container">
            <div className="page-header">
              <h1>Location Group Assignment</h1>
            </div>
            
            <DragDropGroupAssignment />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DragDropDealerGroupPage; 